 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		47: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"0cf660455e789693a80f","1":"982176f2df7f5a19b152","2":"45ef0763bff155a0fdfb","3":"c9e90ab7299b0835417c","4":"c179b5911c22ede98d6d","5":"f47d68b48766b763905a","6":"bcf0361ecaba95aebcc1","7":"a97dbe1bd39410274254","8":"842caa75f9cad1b836cf","9":"b3507aded36d1135f051","10":"6aeab80ba2acb207a4dd","11":"45ebc9ff6373c683fe0a","12":"08744b6e1ef6a5fe7ad9","13":"a1dba13c3a9d27a89646","14":"0e3f06b113f598741bff","15":"6e3a853037bbae0858a0","16":"7a47f74dc82fb6cee1e0","17":"22dfe1a0aa9a3e909741","18":"c970fcd6148ab65caa28","19":"e749bc90597db356c336","20":"3d8bffd1e2e25a9cffef","21":"62ab3dd9b16507d3a8b4","22":"5977eebf4e905f99ba3d","23":"1310145cbafba9534f73","24":"148711f94079119031e9","25":"846d93dd74d4c21e7944","26":"ca49ffaf0ae2cbc8ba67","27":"dc9ba304837d82582cd0","28":"7b7ad165cb65ba9dcd6e","29":"520755d904810608e5c8","30":"80f8835d4d0c3d76626a","31":"454f1edbe01139b65caf","32":"f4804430e16ab3cf8c88","33":"b330a064008380bdd000","34":"41b185214cb18f234b38","35":"aae122bfce0c610063b4","36":"e2f3ef354b444162d899","37":"e7b757536d981134f5bd","38":"8994a2a170bafae16cc1","39":"405072d364206848a0f5","40":"e8c53f0923147286087b","41":"82ad20bdd58acb7adf1c","42":"df7518d167fc1883f131","43":"56babc4d9209975d2a51","44":"8a70c0a08c7d53aa7682","45":"4c4bc86cd3fb01397b0e","46":"b8b62333fe3e12d73d85","48":"bb16d34b63c80c3e1b06","49":"4108c4094b23b6bffbd1","50":"4848f44530b740aea499","51":"fdc34434056327d905de","52":"41c22eb801019c65e225","53":"2c0771abd795b217388b","54":"a620a78ab9eb064cb1dc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"0cf660455e789693a80f","1":"982176f2df7f5a19b152","2":"45ef0763bff155a0fdfb","3":"c9e90ab7299b0835417c","4":"c179b5911c22ede98d6d","5":"f47d68b48766b763905a","6":"bcf0361ecaba95aebcc1","7":"a97dbe1bd39410274254","8":"842caa75f9cad1b836cf","9":"b3507aded36d1135f051","10":"6aeab80ba2acb207a4dd","11":"45ebc9ff6373c683fe0a","12":"08744b6e1ef6a5fe7ad9","13":"a1dba13c3a9d27a89646","14":"0e3f06b113f598741bff","15":"6e3a853037bbae0858a0","16":"7a47f74dc82fb6cee1e0","17":"22dfe1a0aa9a3e909741","18":"c970fcd6148ab65caa28","19":"e749bc90597db356c336","20":"3d8bffd1e2e25a9cffef","21":"62ab3dd9b16507d3a8b4","22":"5977eebf4e905f99ba3d","23":"1310145cbafba9534f73","24":"148711f94079119031e9","25":"846d93dd74d4c21e7944","26":"ca49ffaf0ae2cbc8ba67","27":"dc9ba304837d82582cd0","28":"7b7ad165cb65ba9dcd6e","29":"520755d904810608e5c8","30":"80f8835d4d0c3d76626a","31":"454f1edbe01139b65caf","32":"f4804430e16ab3cf8c88","33":"b330a064008380bdd000","34":"41b185214cb18f234b38","35":"aae122bfce0c610063b4","36":"e2f3ef354b444162d899","37":"e7b757536d981134f5bd","38":"8994a2a170bafae16cc1","39":"405072d364206848a0f5","40":"e8c53f0923147286087b","41":"82ad20bdd58acb7adf1c","42":"df7518d167fc1883f131","43":"56babc4d9209975d2a51","44":"8a70c0a08c7d53aa7682","45":"4c4bc86cd3fb01397b0e","46":"b8b62333fe3e12d73d85","48":"bb16d34b63c80c3e1b06","49":"4108c4094b23b6bffbd1","50":"4848f44530b740aea499","51":"fdc34434056327d905de","52":"41c22eb801019c65e225","53":"2c0771abd795b217388b","54":"a620a78ab9eb064cb1dc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2337);
